var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-spin", {
    attrs: {
      spinning: _vm.showSpinning
    }
  }, [_c("a-card", {
    attrs: {
      bordered: false
    }
  }, [_c("a-form-model", {
    ref: "formModel",
    attrs: {
      model: _vm.form,
      rules: _vm.rules
    }
  }, [_c("a-form-model-item", {
    key: "sitename",
    staticStyle: {
      width: "30%"
    },
    attrs: {
      prop: "siteDomainName"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t("deploy.siteDomainName")) + " "), _c("a-tooltip", {
    attrs: {
      placement: "topLeft",
      title: _vm.$t("deploy.title1")
    }
  }, [_c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 1)], 1), _c("a-input", {
    attrs: {
      allowClear: "",
      maxLength: 100
    },
    model: {
      value: _vm.form.siteDomainName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "siteDomainName", $$v);
      },
      expression: "form.siteDomainName"
    }
  })], 1), _c("a-form-model-item", {
    key: "domain",
    staticStyle: {
      width: "30%"
    },
    attrs: {
      prop: "pictureDomainName"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t("deploy.pictureDomainName")) + " "), _c("a-tooltip", {
    attrs: {
      placement: "topLeft",
      title: _vm.$t("deploy.title3")
    }
  }, [_c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 1)], 1), _c("a-input", {
    attrs: {
      allowClear: "",
      maxLength: 100
    },
    model: {
      value: _vm.form.pictureDomainName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "pictureDomainName", $$v);
      },
      expression: "form.pictureDomainName"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("deploy.ysDataSync")
    }
  }, [_c("a-radio-group", {
    on: {
      change: _vm.changeYs
    },
    model: {
      value: _vm.form.ysDataSync,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "ysDataSync", $$v);
      },
      expression: "form.ysDataSync"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("deploy.open")) + " ")]), _c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("deploy.close")) + " ")])], 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("deploy.googleStatus")
    }
  }, [_c("a-radio-group", {
    on: {
      change: _vm.changeGoogle
    },
    model: {
      value: _vm.form.googleStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "googleStatus", $$v);
      },
      expression: "form.googleStatus"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("deploy.open")) + " ")]), _c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("deploy.close")) + " ")])], 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("deploy.fbStatus")
    }
  }, [_c("a-radio-group", {
    on: {
      change: _vm.changeFb
    },
    model: {
      value: _vm.form.fbStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fbStatus", $$v);
      },
      expression: "form.fbStatus"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("deploy.open")) + " ")]), _c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("deploy.close")) + " ")])], 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("deploy.aliInvalidMailSync")
    }
  }, [_c("a-radio-group", {
    on: {
      change: _vm.changeAli
    },
    model: {
      value: _vm.form.aliInvalidMailSync,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "aliInvalidMailSync", $$v);
      },
      expression: "form.aliInvalidMailSync"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("deploy.open")) + " ")]), _c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("deploy.close")) + " ")])], 1)], 1), _c("a-form-model-item", [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_vm._v(" " + _vm._s(_vm.$t("deploy.tbjs")) + " "), _c("a-tooltip", {
    attrs: {
      placement: "topLeft",
      title: _vm.$t("deploy.title4")
    }
  }, [_c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 1)], 1), _c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.syncLoading
    },
    on: {
      click: _vm.sync
    }
  }, [_vm._v(_vm._s(_vm.syncLoading ? _vm.$t("deploy.asyncing") : _vm.$t("deploy.async")))]), _vm.syncShow && !_vm.syncLoading ? _c("span", {
    style: {
      color: _vm.syncContent ? "blue" : "red",
      "font-size": "14px",
      "margin-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.syncContent ? _vm.$t("deploy.asyncComplete") : _vm.$t("deploy.syncError")))]) : _vm._e()], 1), _c("a-form-model-item", [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_vm._v(" " + _vm._s(_vm.$t("deploy.sync60Erp")) + " ")]), _c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.syncErpLoading
    },
    on: {
      click: _vm.sync60Erp
    }
  }, [_vm._v(_vm._s(_vm.syncErpLoading ? _vm.$t("deploy.asyncing") : _vm.$t("deploy.async")))]), _vm.syncErpShow && !_vm.syncErpLoading ? _c("span", {
    style: {
      color: _vm.syncErpContent ? "blue" : "red",
      "font-size": "14px",
      "margin-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.syncErpContent ? _vm.$t("deploy.asyncComplete") : _vm.$t("deploy.syncError")))]) : _vm._e()], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("deploy.columnsTemplature")
    }
  }, [_c("StandardTableVue", {
    staticStyle: {
      width: "70%"
    },
    attrs: {
      columns: _vm.columnsTemplature,
      dataSource: _vm.dataTemperature,
      pagination: false,
      rowKey: "id"
    },
    scopedSlots: _vm._u([{
      key: "num",
      fn: function fn(record) {
        return [_vm._v(" " + _vm._s(record.index + 1) + " ")];
      }
    }])
  })], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("deploy.columnsTransport")
    }
  }, [_c("StandardTableVue", {
    staticStyle: {
      width: "70%"
    },
    attrs: {
      columns: _vm.columnsTransport,
      dataSource: _vm.dataTransport,
      pagination: false,
      rowKey: "id"
    },
    scopedSlots: _vm._u([{
      key: "num",
      fn: function fn(record) {
        return [_vm._v(" " + _vm._s(record.index + 1) + " ")];
      }
    }])
  })], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("deploy.columnsUrl")
    }
  }, [_c("StandardTableVue", {
    staticStyle: {
      width: "70%"
    },
    attrs: {
      columns: _vm.columnsUrl,
      dataSource: _vm.dataUrl,
      pagination: false,
      rowKey: "type"
    },
    scopedSlots: _vm._u([{
      key: "num",
      fn: function fn(record) {
        return [_vm._v(" " + _vm._s(record.index + 1) + " ")];
      }
    }])
  })], 1)], 1), _c("footer-tool-bar", [_c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.loadingSave
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.save")))])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };